import { Module } from 'vuex';
import { State as RootState } from '../store';

export interface News2Data {
  conscLevel: string | null;
  supplementaryOxygen: string | null;
  temperature: number | null;
  heartRate: number | null;
  respiratoryRate: number | null;
  oxygenSaturation: number | null;
  sbp: number | null;
}

const news2: Module<News2Data, RootState> = {
  namespaced: true,
  state: {
    conscLevel: null,
    supplementaryOxygen: null,
    temperature: null,
    heartRate: null,
    respiratoryRate: null,
    oxygenSaturation: null,
    sbp: null
  },
  mutations: {
    setAnswer(state, { key, value }) {
      (state as any)[key] = value;
    },
    reset(state) {
      Object.keys(state).forEach(k => (state as any)[k] = null);
    }
  },
  getters: {
    isComplete: state =>
      state.conscLevel !== null &&
      state.supplementaryOxygen !== null &&
      state.temperature !== null &&
      state.heartRate !== null &&
      state.respiratoryRate !== null &&
      state.oxygenSaturation !== null &&
      state.sbp !== null,
  }
}

export default news2
